import { autoinject, bindable, observable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { AsyncErrorHandler } from 'lib/ui';
import { WeldingMachineDto } from 'models/pen/WeldingMachine';
import { ErrorService } from 'services/error-service';

@autoinject
export class WeldingMachineCreateEdit {
  @bindable
  @observable
  model: WeldingMachineDto = new WeldingMachineDto();
  modelChanged(model: WeldingMachineDto) {
    if (!model) return;
    this.form = JSON.parse(JSON.stringify(model));
  }

  @bindable
  onSave: (data: { data: WeldingMachineDto }) => void;

  @bindable
  onCanceled: () => void;

  @bindable
  visible = false;

  protected form: WeldingMachineDto = new WeldingMachineDto();

  constructor(
    private errorService: ErrorService,
    private validationController: ValidationController,
    private validator: Validator,
    private t: I18N
  ) {}

  protected applyValidationRules() {
    ValidationRules.ensure('Manufacturer')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('MachineNumber')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Model')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .on(this.form);
  }

  attached() {
    this.applyValidationRules();
  }

  private async validate() {
    this.applyValidationRules();
    await this.validator.validateObject(this.form);
    return (await this.validationController.validate({ object: this.form })).valid;
  }

  @AsyncErrorHandler
  async save() {
    const valid = await this.validate();
    if (!valid) return;
    this.onSave({ data: this.form });
  }

  cancel() {
    this.onCanceled?.();
  }
}
